// CURRENT_ENV is replaced at deploy time (replace-env with VITE_ENV_NAME=PROD|DEV|LOCAL). Default: LOCAL.
import { getConfig } from 'frontend_configmap_package';

const CURRENT_ENV = '__ENV_NAME__';

export default getConfig(CURRENT_ENV, 'linkedin-scraping-dashboard');
